import { hookstate } from '@hookstate/core';

export const itemCurrent = hookstate({ });
